<template>
  <div>
    <ResponseMessageDialog
      v-model="responseMessageDialog.status"
      :error="responseMessageDialog.error"
      :message="responseMessageDialog.message"
    />

    <v-container>
      <LoadingDialog v-model="loading" v-if="loading" />
      <div v-else>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>
            {{ loanProductDetails.id }}.
            {{ loanProductDetails.product_title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="activateEditMode">Edit</v-btn>
        </v-toolbar>
        <br />
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="loanProductDetails.product_title"
            ref="title"
            :rules="[(v) => !!v || 'Product Title is required']"
            label="Product Title *"
            required
            :readonly="readonly"
          ></v-text-field>

          <v-text-field
            v-model="loanProductDetails.product_subtitle"
            :rules="[(v) => !!v || 'Product Subtitle is required']"
            label="Product Subtitle"
            required
            :readonly="readonly"
          ></v-text-field>

          <h3>Descriptions:</h3>

          <div
            v-for="(description, index) in loanProductDetails.requirements
              .description"
            :key="`description${index}`"
          >
            <v-layout row wrap>
              <v-flex xs11>
                <h4>{{ index + 1 }}:</h4>
              </v-flex>
              <v-flex xs1>
                <v-icon
                  color="error"
                  class="deleteDescription"
                  @click="deleteDescription(index)"
                >
                  delete
                </v-icon>
              </v-flex>
            </v-layout>
            <v-text-field
              v-model="description.title"
              :rules="[(v) => !!v || 'Title is required']"
              label="Title *"
              required
              :readonly="readonly"
            ></v-text-field>
            <Editor
              v-model="description.content"
              :disabled="readonly"
              api-key="fh5l4vk9uirbxwfqtidc9gizmwktenx9yy9mh4e61o93tsjx"
              :init="{
                height: 500,
                readonly: 1,
                plugins: [
                  'advlist autolink lists link image charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount',
                ],
                toolbar:
                  'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | help',
              }"
            />
            <br />
            <v-textarea
              outline
              name="input-7-4"
              label="Content *"
              v-model="description.content"
              :rules="[(v) => !!v || 'Content is required']"
              required
              :readonly="readonly"
            ></v-textarea>
          </div>

          <v-icon
            color="success"
            class="addDescription"
            @click="addNewDescription"
          >
            note_add
          </v-icon>
          <br />
          <br />
          <h3>Documents:</h3>
          <br />
          <div
            v-for="(document, index) in loanProductDetails.requirements
              .documents"
            :key="`document${index}`"
          >
            <v-layout>
              <v-flex xs3>
                <h4>{{ ++index }}. {{ document.label }}:</h4>
              </v-flex>
              <v-flex xs3>
                <v-switch
                  :readonly="readonly"
                  v-model="document.required"
                  :label="document.required ? 'Required' : 'Optional'"
                ></v-switch>
              </v-flex>
            </v-layout>
          </div>
          <h3>Bank Account Required:</h3>
          <v-switch
            :readonly="readonly"
            v-model="loanProductDetails.requirements.bank_account_required"
            :label="
              loanProductDetails.requirements.bank_account_required
                ? 'Yes'
                : 'No'
            "
          ></v-switch>
          <h3>Other Contact Info Required:</h3>
          <v-switch
            :readonly="readonly"
            v-model="loanProductDetails.requirements.other_contact_required"
            :label="
              loanProductDetails.requirements.other_contact_required
                ? 'Yes'
                : 'No'
            "
          ></v-switch>

          <br />
          <h3>Status:</h3>
          <v-switch
            :readonly="readonly"
            v-model="loanProductDetails.status"
            :label="loanProductDetails.status ? 'Active' : 'Disabled'"
          ></v-switch>

          <br />
          <v-text-field
            v-model="loanProductDetails.order"
            :rules="[(v) => !!v || 'Order is required']"
            label="Order *"
            required
            :readonly="readonly"
          ></v-text-field>
          <br />

          <v-btn
            :loading="loading"
            :disabled="!valid || readonly || loading"
            color="primary"
            @click="save"
          >
            Save
          </v-btn>
        </v-form>
      </div>
    </v-container>
  </div>
</template>

<script>
  import HTTP from "@/utils/HTTP";
  import { loanProductUrl } from "@/utils/variables";
  import Editor from "@tinymce/tinymce-vue";
  import LoadingDialog from "@/components/Dialogs/LoadingDialog.vue";
  import ResponseMessageDialog from "@/components/Dialogs/ResponseMessageDialog.vue";

  export default {
    components: {
      Editor,
      LoadingDialog,
      ResponseMessageDialog,
    },
    data() {
      return {
        loading: true,
        loanProductDetails: null,
        loanProductNewDescription: {
          title: null,
          content: null,
        },
        readonly: true,
        valid: false,
        responseMessageDialog: {
          status: false,
          error: 0,
          message: "",
        },
      };
    },
    created() {
      this.initialize();
    },
    methods: {
      async initialize() {
        try {
          const { data } = await HTTP().get(loanProductUrl, {
            params: {
              loan_product_id: this.$route.params.id,
            },
          });
          this.loanProductDetails = data.data;

          if (this.loanProductDetails.requirements) {
            this.loanProductDetails.requirements.description
              ? ""
              : (this.loanProductDetails.requirements.description = []);

            this.loanProductDetails.requirements.additional_infos
              ? ""
              : (this.loanProductDetails.requirements.additional_infos = []);

            this.loanProductDetails.requirements.payment_methods
              ? ""
              : (this.loanProductDetails.requirements.payment_methods = []);
          } else {
            this.loanProductDetails.requirements = {
              description: [],
              additional_infos: [],
              payment_methods: [],
              bank_account_required: false,
              other_contact_required: false,
            };
          }
        } finally {
          this.loading = false;
        }
      },

      async save() {
        const valid = await this.$refs.form.validate();
        if (valid) {
          this.loading = true;
          this.loanProductDetails.status = this.loanProductDetails.status
            ? 1
            : 0;
          this.loanProductDetails.requirements = JSON.stringify(
            this.loanProductDetails.requirements
          );
          try {
            const { data } = await HTTP().post(
              `${loanProductUrl}/${this.loanProductDetails.id}`,
              this.loanProductDetails
            );
            this.loanProductDetails = data.data;

            this.responseMessageDialog.error = data.error;
            this.responseMessageDialog.message = data.errorMsg;
          } finally {
            this.responseMessageDialog.status = true;
            this.loading = false;
          }
        }
      },

      activateEditMode() {
        this.readonly = false;
        this.$refs.title.focus();
      },

      addNewDescription() {
        const description = this.loanProductDetails.requirements.description;
        description.push(this.loanProductNewDescription);
      },

      deleteDescription(index) {
        const confirmation = confirm(
          "Are you sure you want to remove this description ?"
        );
        confirmation
          ? this.loanProductDetails.requirements.description.splice(index, 1)
          : "";
      },
    },
  };
</script>

<style scoped>
  .progressBar {
    margin-top: 40vh;
  }
  .addDescription {
    font-size: xx-large;
    cursor: pointer;
  }
  .deleteDescription {
    font-size: x-large;
    cursor: pointer;
  }
  .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
  }
</style>
